import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createRegion',
    serviceName: 'shopadmin',
    query: gql`
      mutation createRegion($title: String!, $points: [String]!, $shop_id: String!) {
        createRegion(title: $title, points: $points, shop_id: $shop_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
